import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=16f46375&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f46375')) {
      api.createRecord('16f46375', component.options)
    } else {
      api.reload('16f46375', component.options)
    }
    module.hot.accept("./Booking.vue?vue&type=template&id=16f46375&", function () {
      api.rerender('16f46375', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/booking/Booking.vue"
export default component.exports